export const basicSort = (rowA, rowB, columnId) => {
    const labelA = rowA.values[columnId] || '';
    const labelB = rowB.values[columnId] || '';
    return labelA.localeCompare(labelB);
};
